module.exports = __webpack_public_path__ + "static/media/gb-sct.c6bc169f.svg";